import { IGameState } from "State/Game/IGameState";
import Element from "../Element";
import SpriteComponent from "Component/Render/Sprite";
import TextComponent from "Component/Render/Text";
import TransformComponent from "Component/Transform";
import { getRewardData } from "Utility/RewardHelper";
import { SeasonPassRewardReminder } from "Layouts/Quests/SeasonPass/SeasonPassRewardReminder";
import { NonVariableRewardData } from "Types/Reward";

type SeasonPassReminderRewardItemProps = {
    state: IGameState;
    key: number;
    reward: NonVariableRewardData;
    itemWidth: number;
};

export class SeasonPassReminderRewardItem extends Element {
    private state: IGameState;
    private layout: any;
    private premiumReward: NonVariableRewardData;

    public create(props: SeasonPassReminderRewardItemProps): void {
        const x = props.key * props.itemWidth;

        super.create({
            type: 'group',
            layout: {
                anchors: [0, 0, 0, 0],
                pivot: [0, 0],
                offsets: [-x, 0, -x, 0],
            },
        });

        this.state = props.state;
        this.premiumReward = props.reward;
        this.layout = new SeasonPassRewardReminder();
        this.addChild(this.layout.root);

        this.init();
    }

    public init(): void {
        const premiumRewardData = getRewardData(this.premiumReward.type);

        this.layout.RewardIcon.getComponent(SpriteComponent).texture = premiumRewardData.texture;
        this.layout.RewardText.getComponent(TextComponent).text = `x${this.premiumReward.amount}`;
        this.layout.RewardIcon.getComponent(TransformComponent).scale.set((premiumRewardData.iconScale ?? 1));
    }

    public updateLayout(state: IGameState) {
        this.state = state;
        this.init();
    }

    public destroy() {
        super.destroy();
    }
}
